interface NavigatorWithLegacy extends Navigator {
  msMaxTouchPoints?: number
}

export const isBrowser = typeof window !== 'undefined'
export const isTouchScreen = isBrowser && ('ontouchstart' in window || navigator.maxTouchPoints > 0 || ((navigator as NavigatorWithLegacy).msMaxTouchPoints || 0) > 0)
